module.exports = __webpack_public_path__ + "static/media/add-user.677b8be1.png";